<template>
  <div>
    <div ref="resultsSection" class="max-w-6xl mx-auto">
      <div class="">
        <div class="h-full min-h-screen md:flex">
          <div class="p-6 mb-0 md:hidden">
            <div
              class="px-4 pt-4 pb-5 mx-auto border rounded-lg border-clay-300 bg-clay-100"
            >
              <h3
                class="pb-2 text-sm font-semibold tracking-wide uppercase text-clay-800"
              >
                Favorites by Category
              </h3>
              <label for="mobile-category-select" class="sr-only"
                >Select a category</label
              >
              <select
                id="mobile-category-select"
                name="mobile-category-select"
                v-model="queryCategory"
                @change="onOtherResultsClicked(queryCategory)"
                class="block w-full px-4 py-2 mt-1 text-sm border rounded-md border-clay-300 focus:border-clay-500 focus:ring-clay-500 bg-clay-50 text-clay-900"
              >
                <option
                  v-for="result in otherResults"
                  :key="result.guideType"
                  :value="result.guideType"
                >
                  {{ result.guideType }} ({{
                    isRetrieving ? "..." : result.totalResults
                  }})
                </option>
              </select>
            </div>
          </div>

          <div class="hidden md:flex md:shrink-0">
            <div class="pt-6 pb-12 sm:flex sm:flex-col md:w-54 bg-white">
              <div class="flex flex-col flex-1 min-h-0">
                <div class="flex flex-col flex-1 pt-5 pb-4 overflow-y-auto">
                  <div class="flex items-center px-4 shrink-0"></div>
                  <nav
                    aria-label="Sidebar"
                    class="grid grid-cols-2 gap-4 md:grid-cols-2 sm:grid-cols-3 lg:grid-cols-1 lg:gap-0 md:space-y-2"
                  >
                    <div
                      v-for="result in otherResults"
                      :key="result.guideType"
                      class="space-y-5 text-clay-700 "
                    >
                      <a
                        @click.prevent="onOtherResultsClicked(result.guideType)"
                        :class="
                          result.guideType === queryCategory
                            ? 'text-clay-900 bg-slate-200 font-bold'
                            : ''
                        "
                        class="items-center block min-w-full px-4 py-2 text-sm capitalize rounded-md sm:flex text-clay-800 bg-clay-100 group hover:text-clay-700 hover:bg-clay-50"
                      >
                        {{ result.guideType }} (<em>{{
                          isRetrieving ? "..." : result.totalResults
                        }}</em
                        >)
                      </a>
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>
          <div
            class="flex-col flex-1 min-w-0 overflow-visible md:flex sm:px-6 lg:px-4"
          >
            <div
              class="relative z-0 flex flex-1 mb-12 overflow-visible bg-white"
            >
              <div
                class="relative z-0 flex-1 pt-6 focus:outline-hidden xl:order-last"
              >
                <div class="relative inset-0 px-4 pb-6 sm:px-6 lg:px-8">
                  <div class="h-full pb-8 bg-clay-50 rounded-2xl">
                    <div class="pt-5 pl-4 pr-4 contentful-tab">
                      <div class="guidesTab md:h-full">
                        <div v-if="results">
                          <div
                            class="mx-auto overflow-hidden transition-all transform divide-y divide-gray-200 max-w-7xl "
                          >
                            <SkeletonCard
                              class="mt-3"
                              v-if="isRetrieving"
                              card-style="long"
                              :num-of-cards="4"
                            >
                            </SkeletonCard>
                            <div v-else>
                              <div
                                class="grid gap-6 py-2 mb-8 text-sm text-gray-800 sm:grid-cols-12"
                              >
                                <div
                                  v-for="result in results"
                                  :key="result.id"
                                  :class="getClassForCard"
                                  class="relative flex items-center space-x-3 search-query-cards"
                                >
                                  <ShowCard
                                    v-if="queryCategory === 'Shows'"
                                    :show="result"
                                  />

                                  <CharacterCard
                                    v-else-if="queryCategory === 'Characters'"
                                    :character="result"
                                  ></CharacterCard>
                                  <MonologueCard
                                    v-else-if="queryCategory === 'Monologues'"
                                    :monologue="result"
                                  ></MonologueCard>
                                  <SceneCard
                                    v-else-if="queryCategory === 'Scenes'"
                                    :scene="result"
                                  ></SceneCard>
                                  <SongCard
                                    v-else-if="queryCategory === 'Songs'"
                                    :song="result"
                                  ></SongCard>
                                  <WriterCard
                                    v-else-if="
                                      queryCategory ===
                                        'Playwrights & composers'
                                    "
                                    :writer="result"
                                  ></WriterCard>
                                  <TheatreCompanyCard
                                    v-else-if="queryCategory === 'Companies'"
                                    :company="result"
                                  ></TheatreCompanyCard>
                                  <TalentProfileCard
                                    v-else-if="
                                      queryCategory === 'Talent profiles'
                                    "
                                    :talent="result"
                                  ></TalentProfileCard>
                                  <CollegeProgramCard
                                    v-else-if="
                                      queryCategory === 'College Programs'
                                    "
                                    :program="result"
                                  ></CollegeProgramCard>
                                </div>
                              </div>
                              <paginate
                                v-model="getFavoritesResponse.currentPage"
                                :active-class="
                                  'border-electric-500 text-electric-600 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                "
                                :click-handler="paginationClickHandler"
                                :container-class="
                                  'border-t border-gray-200 px-4 flex items-center justify-between sm:px-0'
                                "
                                :margin-pages="2"
                                :next-class="
                                  '-mt-px w-0 flex-1 flex justify-end'
                                "
                                :next-link-class="
                                  'border-t-2 border-transparent pt-4 pl-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500'
                                "
                                :next-text="nextHtml"
                                :page-class="
                                  'border-transparent text-clay-800 hover:text-gray-700 hover:border-clay-500 border-t-2 pt-4 px-4 inline-flex items-center text-sm font-medium'
                                "
                                :page-count="getPageCount()"
                                :page-range="3"
                                :prev-class="'-mt-px w-0 flex-1 flex'"
                                :prev-link-class="
                                  'border-t-2 border-transparent pt-4 pr-1 inline-flex items-center text-sm font-medium text-clay-800 hover:text-gray-700 hover:border-clay-500'
                                "
                                :prev-text="prevHtml"
                              >
                              </paginate>
                            </div>
                          </div>
                        </div>
                        <div v-else>
                          <div>
                            <div class="text-center">
                              <h2
                                class="mt-2 text-base font-semibold leading-6 text-gray-600"
                              >
                                {{ name }} has not added any favorites to this
                                category just yet.
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
// @ts-ignore
import { computed, defineProps, onMounted, Ref, ref } from "vue";
import { client } from "@/shared";
// @ts-ignore
import Paginate from "vuejs-paginate-next";
import {
  GetTalentFavorites,
  GetTalentFavoritesResponse,
  GuideTypeWithCount
} from "@/dtos";
import ShowCard from "../Guides/Shows/ShowCard.vue";
import CharacterCard from "../Guides/Characters/CharacterCard.vue";
import MonologueCard from "../Guides/Monologues/MonologueCard.vue";
import TalentProfileCard from "../Talent/TalentProfileCard.vue";
import SceneCard from "../Guides/Scenes/SceneCard.vue";
import SongCard from "../Guides/Songs/SongCard.vue";
import WriterCard from "../Guides/Writers/WriterCard.vue";
import TheatreCompanyCard from "../TheatreCompanies/TheatreCompanyCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";
import _ from "lodash";
import CollegeProgramCard from "../CollegePrograms/CollegeProgramCard.vue";

const props = defineProps({
  url: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: "Shows"
  },
  name: {
    type: String
  }
});

const resultsSection = ref(null);
const getFavoritesResponse = ref<GetTalentFavoritesResponse>({});
const results: any = ref<[]>([]);
const otherResults = ref<Array<GuideTypeWithCount>>([]);
const queryCategory = ref("");
const request: Ref<GetTalentFavorites> = ref({});
const isRetrieving = ref(false);

onMounted(async () => {
  let category = "Shows";
  queryCategory.value = getValidCategoryOrDefault(decodeURIComponent(category));
  await getFannedItemsByCategory(true);
});

const getFannedItemsByCategory = async (isPageLoad: boolean = false) => {
  if (!isPageLoad) {
    resultsSection.value.scrollIntoView({ behavior: "smooth" });
  }

  if (isPageLoad) {
    resetPagination();
  }

  isRetrieving.value = true;

  request.value.url = props.url;
  request.value.guideType = queryCategory.value;
  console.log("clicked");

  await client
    .get<GetTalentFavoritesResponse>(new GetTalentFavorites(request.value))
    .then(res => {
      getFavoritesResponse.value = res;
      queryCategory.value = res.guideType;
      results.value = res.results;
      otherResults.value = res.guideTypesWithCounts;
      isRetrieving.value = false;
    });
};

let hasResults = computed(() => {
  return results.value?.length > 0;
});

const onOtherResultsClicked = async (clickedCategory: string) => {
  queryCategory.value = clickedCategory;
  resetPagination();
  await getFannedItemsByCategory();
};

const paginationClickHandler = async (pageNum: any) => {
  request.value.currentPage = pageNum;
  await getFannedItemsByCategory();
};

const resetPagination = () => {
  request.value.currentPage = 1;
};

const getPageCount = () => {
  return Math.ceil(getFavoritesResponse.value.totalResults / 12);
};

let getClassForCard = computed(() => {
  let fourCol = "sm:col-span-6 col-span-12 md:col-span-3";
  let threeCol = "md:col-span-4 sm:col-span-6 col-span-12";
  let twoCol = "sm:col-span-6 col-span-12";

  switch (queryCategory.value) {
    case "Shows":
      return threeCol;
    case "Companies":
    case "College Programs":
      return threeCol;
    case "Talent profiles":
      return threeCol;
    default:
      return twoCol;
  }
});

const getValidCategoryOrDefault = (incomingCategory: string) => {
  let validCategories = {
    Shows: ["Shows", "shows"],
    Characters: ["Characters", "characters"],
    "Playwrights & composers": [
      "Playwrights & composers",
      "Writers",
      "writers"
    ],
    Songs: ["Songs", "songs"],
    Monologues: ["Monologues", "monologues"],
    Scenes: ["Scenes", "scenes"],
    "Talent profiles": [
      "Talent profiles",
      "talent profiles",
      "Talent",
      "talent"
    ],
    Companies: ["Companies", "companies", "theatre companies", "theatre"],
    "College Programs": [
      "College programs",
      "College Programs",
      "college",
      "programs"
    ]
  };

  let category = _.findKey(validCategories, function(cat) {
    return cat.includes(incomingCategory);
  });

  return category ?? "Shows";
};

let nextHtml = `<span class="hidden md:inline-block">Next</span>
                        <svg class="w-5 h-5 ml-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>`;

let prevHtml = `<svg class="w-5 h-5 mr-3 text-gray-400" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd" />
                        </svg>
                        <span class="hidden md:inline-block">Previous</span>`;
</script>
